import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IProduto } from '../types/IProduto';

@Injectable({ providedIn: 'root' })
export class OperadoraState {
  private _operadoraSelecionada: IProduto | null = null;
  private operadoraSelecionada = new BehaviorSubject<IProduto | null>(null);

  setOriginalState(operadora: IProduto) {
    this._operadoraSelecionada = operadora;
    this.selectOperadora(this._operadoraSelecionada);
  }

  selectOperadora(operadora: IProduto) {
    this.operadoraSelecionada.next(operadora);
  }

  getOperadoraSelecionada() {
    return this.operadoraSelecionada.getValue();
  }

  observeOperadoraSelecionada() {
    return this.operadoraSelecionada.asObservable();
  }

  resetToOriginalState() {
    this.operadoraSelecionada.next(this._operadoraSelecionada);
  }

  filterByUf(ufDescription: string) {
    if(this.getOperadoraSelecionada()) {
      const operadoraFiltrada = this.deepCopyObject<IProduto>(this._operadoraSelecionada);

      if(operadoraFiltrada.material_venda) {
        operadoraFiltrada.material_venda = operadoraFiltrada.material_venda.filter(material => {
          if(this.shouldNotFilter(material.ufs))
            return true;
          else
            return material.ufs?.includes(ufDescription)
        });
      }

      if(operadoraFiltrada.material_venda_arquivos?.bloco?.length > 0) {
        operadoraFiltrada.material_venda_arquivos.bloco = operadoraFiltrada.material_venda_arquivos.bloco.map(bloco => {
          bloco.links = bloco.links.filter(link => {
            if(this.shouldNotFilter(link.ufs))
              return true;
            else
              return link.ufs?.includes(ufDescription)
          });

          return bloco;
        });
      }

      if(operadoraFiltrada.material_venda_arquivos?.links?.length > 0) {
        operadoraFiltrada.material_venda_arquivos.links = operadoraFiltrada.material_venda_arquivos.links.filter(link => {
          if(this.shouldNotFilter(link.ufs))
            return true;
          else
            return link.ufs?.includes(ufDescription);
        });
      }

      if(operadoraFiltrada.material_treinamento?.links?.length > 0) {
        operadoraFiltrada.material_treinamento.links = operadoraFiltrada.material_treinamento.links.filter(link => {
          if(this.shouldNotFilter(link.ufs))
            return true;
          else
            return link.ufs?.includes(ufDescription);
        });
      }

      this.selectOperadora(operadoraFiltrada);
    }
  }

  reset() {
    this.operadoraSelecionada = null;
    this._operadoraSelecionada = null;
  }

  private deepCopyObject<T>(obj: Object): T {
    return JSON.parse(JSON.stringify(obj));
  }

  private shouldNotFilter(ufs: string[] | null | undefined): boolean {
    return !ufs;
  }
}